module.exports = __webpack_public_path__ + "static/img/grace_365.44d16e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/grace_365.png
// module id = 0sC0
// module chunks = 0